import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import classNames from "classnames";
import "./style.scss";

const BackButton = ({ handleBack, title, className }) => {
  return (
    <div className={classNames("c-back-btn", className)}>
      <ArrowBackOutlinedIcon
        onClick={handleBack}
        sx={{fontSize: 24, color: "#0091DA", cursor: "pointer"}}
      />
      <h2>{title}</h2>
    </div>
  );
};

export default BackButton;
